import { createApi } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";
export const importproductMainApi = createApi({
    reducerPath: "importproductmainApi",
    baseQuery,
    tagTypes: ["ProductMain"],
    endpoints: (builder) => ({
    
        createProductMain: builder.mutation({
            query: ({ id, ...data }) => ({
              url: `/import/product/main/${id}`,
              method: "PUT",
              body: { ProductMain: data }, //importproductMain
            }),
            invalidatesTags: ["productMain"],
          }),

        getProductInvoiceMainId: builder.query({
            query: ({id}) => `import/product/main/${id}`,
            transformResponse: (response) => 
              {
                const data= response?.data?.importProductMain ?? [];
                const normalized = Array.isArray(data) ? data : [data];
                return normalized.map((item,index) => ({
                  ...item,
                  SrNo:index+1,
                  id: item.importProductId, 
                  totalAmount: response?.data?.totalAmount || 0,
                  eximCode: response?.data?.eximScheme || "",
                  assessbleValue:response?.data?.assessbleValue || 2121,
                  dutypaidTotal:response?.data?.dutypaidTotal || "",
                  importProductMainDescriptionId:
                  item.importProductMainDescriptionId !== null &&
                  item.importProductMainDescriptionId !== undefined
                    ? item.importProductMainDescriptionId
                    : item.importProductMainDescription,
                }));

              },
            providesTags: ["productMain"],
          }), 

          getProductById: builder.query({
            query: ({ id, subId }) => `import/product/main/${id}/${subId}`,
            transformResponse: (response) => {
              return response?.data ?? [];
            },
            providesTags: ["productMain"],
          }),
          updateProductMain: builder.mutation({
            query: ({ id, subId, ...data }) => ({
              url: `/import/product/main/${id}/${subId}`,
              method: "PUT",
              body: { ProductMain: data },
            }),
            invalidatesTags: ["productMain"],
          }),

          deleteProductMain: builder.mutation({
            query: ({ id}) => {
              return {
                url: `import/product/main/${id}`,
                method: "DELETE",
              };
            },
            invalidatesTags: ["productMain"],
          }),





     
    }),
});
export const {
    useCreateProductMainMutation,
    useLazyGetProductInvoiceMainIdQuery,
    useUpdateProductMainMutation,
  useDeleteProductMainMutation,
    

    
  } = importproductMainApi;